// src/pages/ContraRecord/index.js
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import { ArrowLeftOutlined, DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { useReactToPrint } from "react-to-print";
import ContraRecordFilters from "./components/ContraRecordFilters";
import ContraRecordTable from "./components/ContraRecordTable";
import ReportDom from "../../../components/common/ReportDom";
import { useNavigate } from "react-router-dom";
import { exportContraRecordCsv } from "./components/exportContraRecordCsv";

const { Title } = Typography;

const ContraRecord = () => {
  const { filters, list, listWithDetails } = useSelector(  // 👈 added list & listWithDetails
    (state) => state.contraRecord
  );
  const reportRef = useRef(null);
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const navigate = useNavigate();

  const handleNavigateToReports = () => {
    navigate("/reports");
  };

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Contra Record Report",
    removeAfterPrint: true,
  });
  const handleDownloadCsv = () => {
    exportContraRecordCsv({
      list,
      listWithDetails,
      filters,
      title:    "Contra Record Report",
      filename: "contra_record",
    });
  };

  // mirrors ContraRecordTable's dataSource logic
  const activeData =
    filters.recordType === "with details" ? listWithDetails : list;

  const hasData = activeData.length > 0;
  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
           <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                type="text"
                icon={<ArrowLeftOutlined />}
                onClick={handleNavigateToReports}
                style={{ marginRight: 8 }}
              /> 
          <Title level={4}>Contra Record</Title>
          </div>
        }
 extra={
            <Flex gap={8}>
              {hasData && (
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
              )}
              <Button
                type="primary"
                icon={<PrinterOutlined />}
                onClick={handlePrint}
              >
                {!screens.xs && "Print"}
              </Button>
            </Flex>
          }
        />

        <ContraRecordFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <ContraRecordTable />
        </Card>
      </App>

      {/* Print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Contra Record Report"
          mode="report-page"
          filters={filters}
          renderTable={() => <ContraRecordTable pagination={false} printMode />}
          footer
        />
      </div>
    </div>
  );
};

export default ContraRecord;
